import { Injectable } from '@angular/core';
import { SettingsService } from 'src/app/shared/data-service/settings.service';
import { StoreService } from 'projects/dop-core/src/public-api';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { DisplayPrice } from 'src/app/shared/enums/display-price.enum';
import { StoreKey } from 'src/app/core/store/ngrx-store.keys';
import { UserManagementDataService } from 'src/app/shared/data-service/user-management-data.service';
import { map } from 'rxjs/operators';
import { UserType } from 'src/app/shared/enums/user-type.enum';

@Injectable({
    providedIn: 'root'
})
export class DisplayPriceService {

    constructor(
        private settingsService: SettingsService,
        private storeService: StoreService,
        private userManagementService: UserManagementDataService) {

    }

    async checkShowPrice(osDisplayPricing: DisplayPrice, accountCode: string) {
        const settingValue = await this.settingsService.getSettingValue(SettingsKey.PricingAtOrderingServiceLevel);
        if (JSON.parse(settingValue.toLowerCase())) {
            switch (osDisplayPricing) {
                case DisplayPrice.CheckAccountPermission:
                    return await this.checkAccountLevelPricePermission(accountCode);
                case DisplayPrice.True:
                    return true;
                default:
                    return false;
            }
        }
        return await this.checkAccountLevelPricePermission(accountCode);
    }

    private async checkAccountLevelPricePermission(accountCode: string) {
        const userDetails: any = await this.storeService.Get(StoreKey.UserDetails).toPromise();
        const isInternalUser = userDetails.profile.userType.toString().toLowerCase() === UserType[1].toString().toLowerCase() || userDetails.profile.userType.toString().toLowerCase() === UserType[2].toString().toLowerCase();
        return await this.canViewPriceAccountLevel(isInternalUser, accountCode).toPromise();
    }

    private canViewPriceAccountLevel(isInternalUser: boolean, accountCode: string) {
        return this.userManagementService.getCanViewPricePermission(isInternalUser, accountCode)
            .pipe(map(operation => {
                return isInternalUser ? operation.applicationOperationNames.length > 0 :
                    operation.accountOperationPermissions.length > 0;
            }));
    }
}
